import { render } from "./Startup.vue?vue&type=template&id=2adf83ea&ts=true"
import script from "./Startup.vue?vue&type=script&lang=ts"
export * from "./Startup.vue?vue&type=script&lang=ts"

import "./Startup.vue?vue&type=style&index=0&id=2adf83ea&lang=scss"

import exportComponent from "/var/www/tenanthub.au/runners/admin/root/tenanthub-admin/tenanthub-admin/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__